import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_VERSION } from '@app/core/api.version';

@Injectable()
export class EmailsService {

  constructor(
    private http: HttpClient,
  ) { }


  createSubscription(email: string, mailing_list_id: number) {
    return this.http.post(`/${API_VERSION}/mailing_list_participant/`, { email: email, mailing_list_id: 1});
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/emails.service.ts